import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {FaIcon} from "../FaIcon";
import {Spinner} from "../Spinner";
import { withTranslation } from 'react-i18next';

class CreateAdAccountFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        let submit_url = this.urlForSubmit();
        new APIClient(submit_url).call('POST', {'email': event.target.email.value}).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.props.afterSubmit()
            }
        })
    }

    urlForSubmit() {
        return API_URL + 'invitation/send';
    }

    renderSaveButton() {
        if (!this.state.saving) {
            const { t } = this.props;
            return <input type="submit" value={t('client.send_button')} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    {/*<div className="modal-section">*/}
                    {/*    <div className="form-row">*/}
                    {/*        <label>Email address</label>*/}
                    {/*        <input name="email" type="text"/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="modal-section">{t('create_account.not_developed')}</div>
                </ModalBody>
                {/*<ModalFooter>*/}
                {/*    {this.renderSaveButton()}*/}
                {/*</ModalFooter>*/}
            </form>
        )
    }
}

class CreateAdAccountModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSubmit() {
        this.toggle();
        this.props.onAdAccountCreated();
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Button className="btn -alt" onClick={this.toggle}>
                    <FaIcon iconName="user-plus"/>
                    {t('create_ad_account_modal.create_advertising_account')}
                </Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}><FaIcon iconName="user-plus"/>{t('create_ad_account_modal.create_new_advertising_account')}</ModalHeader>
                    <CreateAdAccountForm closeModal={this.toggle} afterSubmit={this.afterSubmit}/>
                </Modal>
            </div>
        );
    }
}

export const CreateAdAccountForm = withTranslation()(CreateAdAccountFormComponent);
export const CreateAdAccountModal = withTranslation()(CreateAdAccountModalComponent);

